export const GET_LOCKED_VISITS = '[ADMIN] GET_LOCKED_VISITS';
export const GET_LOCKED_VISITS_START = '[ADMIN] GET_LOCKED_VISITS_START';
export const GET_LOCKED_VISITS_SUCCESS = '[ADMIN] GET_LOCKED_VISITS_SUCCESS';
export const GET_LOCKED_VISITS_ERROR = '[ADMIN] GET_LOCKED_VISITS_ERROR';
export const UNLOCK_VISIT = '[ADMIN] UNLOCK_VISIT';
export const UNLOCK_VISIT_START = '[ADMIN] UNLOCK_VISIT_START';
export const UNLOCK_VISIT_ERROR = '[ADMIN] UNLOCK_VISIT_ERROR';
export const UNLOCK_VISIT_SUCCESS = '[ADMIN] UNLOCK_VISIT_SUCCESS';

export const fetchLockedVisits = () => {
    return {
        type: GET_LOCKED_VISITS,
        payload: null
    };
}

export const unlockVisit = (visit) => {
    return {
        type: UNLOCK_VISIT,
        visit
    }
}